<template>
  <Modal title="约测网课" v-model="visible" :mask-closable="false">
    <Form ref="testNetworkForm" class="form"
      :model="testNetworkParam" :rules="ruleTestNetwork"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学生信息">
            <label>{{ testNetworkParam.uid }}  - {{ testNetworkParam.mobile }} - {{ testNetworkParam.nickname }}</label>
          </Form-item>
        </Col>
        <Col :span="12">
          <Form-item label="开始Level" prop="levelId">
            <Select v-model.number="testNetworkParam.levelId" placeholder="请选择等级，支持搜索"
              @on-change="changeLevel">
              <Option v-for="item in bookMaterialLevelList"
                :value="item.id" :key="item.id">{{ item.title }}(版本{{item.materialVersion}})</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="教室" prop="schoolId" >
            <Select v-model.number="testNetworkParam.schoolId" >
              <Option v-for="item in $constant.schoolEnums"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始课程" prop="lessonId">
            <Select v-model.number="testNetworkParam.lessonId" >
              <Option v-for="item in bookMaterialLessonsList"
                :value="item.id" :key="item.id">{{ item.title }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="老师" prop="tchId">
            <TeacherSelect :category="[3]"
              v-model="testNetworkParam.tchId"></TeacherSelect>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="开始时间" prop="lsnBeginDayTime">
            <Row :gutter="6">
              <Col span="7">
                <Form-item >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                    @on-change="lsnBeginTimeDateChange" :clearable="false"
                    v-model="testNetworkParam.lsnBeginTimeDate"></Date-picker>
                </Form-item>
              </Col>
              <Col span="5">
                <Form-item >
                  <Time-picker @on-change="onChangeTime" :clearable="false" :value="timeStr"
                    format="HH:mm" :steps="[1, 30]" placeholder="时间"></Time-picker>
                </Form-item>
              </Col>
              <Col span="4">
                <Form-item>
                  <Select v-model.number="testNetworkParam.timeLength" >
                    <Option v-for="item in timeLengthList"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col span="5" offset="1">
                <Button type="info" @click="checkTime">检查</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingTestNetwork" @click="insertTestNetwork">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UserTestNetworkModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        classTypeList: [{ code: 1, text: 'ClassIn' }],
        timeLengthList: [{ code: 25, text: '25' }],
        showTestNetworkModal: false,
        bookMaterialLevelList: null,
        bookMaterialLessonsList: null,
        testNetworkParam: {
          uid: '',
          nickname: '',
          mobile: '',
          classType: 1,
          courseType: 1,
          tchId: null,
          levelId: null,
          lessonId: null,
          lsnBeginTimeDate: null,
          lsnBeginTime: null,
          lsnBeginDayTime: null,
          timeLength: 25,
          schoolId: 0,
        },
        timeStr: '',
        loadingCheck: false,
        loadingTestNetwork: false,
        ruleTestNetwork: {
          levelId: [
            { type: 'integer', required: true, message: '请选择开始Level', trigger: 'change' }
          ],
          lessonId: [
            { type: 'integer', required: true, message: '请选择开始课程', trigger: 'change' }
          ],
          classType: [
            { type: 'integer', required: true, message: '请选择教室', trigger: 'change' }
          ],
          tchId: [
            { type: 'integer', required: true, message: '请选择老师', trigger: 'change' }
          ],
          lsnBeginDayTime: [
            { type: 'integer', required: true, message: '请选择日期', trigger: 'change' },
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (self.testNetworkParam.time === '') {
                errors.push('请选择时间')
                callback(errors)
                return
              }
              callback(errors)
            } },
          ]
        },
      }
    },
    methods: {
      changeLevel (val) {
        let self = this
        self.bookMaterialLessonsList = null
        self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLessonsList = res.data
          if (res.data.length > 0) {
            self.testNetworkParam.lessonId = res.data[0].id
          }
        })
      },
      onChangeTime (val) {
        this.testNetworkParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val))
      },
      lsnBeginTimeDateChange (value) {
        this.testNetworkParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      },
      checkTime () {
        let self = this
        let isNotError = true
        self.loadingCheck = true
        self.$refs.testNetworkForm.validateField('tchId', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.testNetworkForm.validateField('lsnBeginDayTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) {
          self.loadingCheck = false
          return
        }
        self.testNetworkParam.lsnBeginTime = self.getLsnBeginTime()
        self.$http.post('/user/lesson/checkTime', self.testNetworkParam).then(function (res) {
          self.loadingCheck = false
          if (res) {
            self.$Message.success('检查成功!')
            return
          }
        })
      },
      insertTestNetwork () {
        let self = this
        self.loadingTestNetwork = true
        self.$refs.testNetworkForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingTestNetwork = false
            return
          }
          self.testNetworkParam.lsnBeginTime = self.getLsnBeginTime()
          self.$http.post('/user/lesson/addCourse', self.testNetworkParam).then(function (res) {
            self.loadingTestNetwork = false
            if (res) {
              self.$Message.success('约课成功!')
              self.visible = false
              return
            }
          })
        })
      },
      loadBookMaterialLevel () {
        let self = this
        if (self.bookMaterialLevelList) {
          return
        }
        self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=0').then(function (res) {
          if (!res || !res.data || res.data.length < 1) {
            return
          }
          self.bookMaterialLevelList = res.data

          self.testNetworkParam.levelId = res.data[0].id
          self.changeLevel(res.data[0].id)
        })
      },
      getLsnBeginTime () {
        return parseInt(this.testNetworkParam.lsnBeginDayTime) + parseInt(this.testNetworkParam.time)
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.loadBookMaterialLevel()
          this.testNetworkParam.uid = this.user.uid
          this.testNetworkParam.nickname = this.user.nickname
          this.testNetworkParam.mobile = this.user.mobile
          this.testNetworkBookMaterialLevelList = this.bookMaterialLevelList

          let now = new Date()
          now = new Date(now.getFullYear(), now.getMonth(), now.getDate())
          this.testNetworkParam.lsnBeginTimeDate = now
          this.testNetworkParam.lsnBeginDayTime = now.getTime() / 1000
          this.timeStr = '18:00'
          this.testNetworkParam.time = 18 * 3600
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserTestNetworkModal.vue?eab51830